const DATA_URI = /^\s*data:(?:([\w-]+)\/([\w+.-]+))?(?:;charset=([\w-]+))?(?:;(base64))?,(.*)/i;
export {
  DATA_URI
};
//# sourceMappingURL=const.mjs.map
